module.exports = __webpack_public_path__ + "img/solaray-social-media-photography.db2c90b7.jpg";